/* eslint-disable import/extensions */
import messagesEn from "../lib/translations/en";
import messagesPl from "../lib/translations/pl";

export default {
  en: messagesEn,
  pl: messagesPl,
};
